import { userService } from "@/_services";
import {
  getToken,
  setToken,
  removeToken,
  getRole,
  setRole,
  removeRole,
  getRule,
  setRule,
  removeRule
} from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
  token: getToken(),
  info: {},
  role: getRole(),
  rules: getRule()
};

const mutations = {
  SET_TOKEN: (state, token) => {
    setToken(token);
    state.token = token;
  },
  SET_INFO: (state, info) => {
    state.info = info;
  },
  SET_ROLE: (state, role) => {
    setRole(role);
    state.role = role;
  },
  SET_RULES: (stat, rules) => {
    let prules = {};
    for (let i = 0; i < rules.length; i++) {
      const feature = rules[i];
      prules[feature.key] =
        feature.rule && feature.rule.access == 1 ? true : false;
    }
    setRule(prules);
    state.rules = prules;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      userService
        .login(username.trim(), password)
        .then(response => {
          const { data } = response;
          commit("SET_TOKEN", data.access_token);
          commit("SET_INFO", data);
          commit("SET_ROLE", data.role);
          commit("SET_RULES", data.rules);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  setLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      try {
        commit("SET_TOKEN", data.access_token);
        commit("SET_INFO", data);
        commit("SET_ROLE", data.role);
        commit("SET_RULES", data.rules);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      userService
        .getInfo()
        .then(response => {
          const { data } = response;
          if (!data) {
            reject("Verification failed, please Login again.");
          }
          commit("SET_INFO", data);
          commit("SET_ROLE", data.role);
          commit("SET_RULES", data.rules);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateInfo({ commit }, body) {
    return new Promise((resolve, rejects) => {
      userService
        .updateInfo(body)
        .then(response => {
          commit("SET_INFO", response.data);
          commit("SET_ROLE", response.data.role);
          commit("SET_RULES", response.data.rules);
          resolve(response);
        })
        .catch(error => {
          rejects(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    commit("SET_TOKEN", "");
    commit("SET_ROLE", {});
    commit("SET_RULES", []);
    removeToken();
    removeRole();
    removeRule();
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLE", {});
      commit("SET_RULES", []);
      removeToken();
      removeRole();
      removeRule();
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
